import { jsx, css } from '@emotion/react';
import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/DiscountGallery.jsx';

export default define`Discount Gallery`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/DiscountGallery`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
